import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@jira/navigation-apps__horizontal-nav-selector/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { projectSettingsCustomerServiceDetailsRoute } from '@jira/router-routes__project-settings-customer-service-routes/src/projectSettingsCustomerServiceDetailsRoute.tsx';
import { projectDetailsPageEntrypoint } from '@jira/spa-apps__project-settings-details/src/projectDetailsPageEntrypoint.entrypoint.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { ProjectSettingsDetailsSkeleton } from '@jira/platform__skeletons/src/ui/project-settings/ProjectSettingsFeaturesSkeleton.tsx';
import type { Route } from '@atlassian/react-resource-router';

const projectSettingsCustomerServiceDetailsPageEntrypoint = createPageEntryPoint({
	main: projectDetailsPageEntrypoint,
});

export const projectSettingsCustomerServiceDetailsRouteEntry: Route = createEntry(
	projectSettingsCustomerServiceDetailsRoute,
	() => ({
		group: 'project-settings-customer-service',
		skeleton: ProjectSettingsDetailsSkeleton,
		layout: serviceProjectLayout,
		entryPoint: () =>
			fg('csm_appification_standalone_navigation')
				? projectSettingsCustomerServiceDetailsPageEntrypoint
				: notFoundPageEntrypoint,
		navigation: {
			horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},
		resources: [...getServiceDeskSettingsResources()],
		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
